import store from './store';
import { mapGetters, mapActions } from 'vuex';

export default {
  created() {
    store.install(this.$store);
  },
  mounted() {
    if (!this.MenuTree.length) {
      this.fetchMenuTree();
    }
  },
  data() {
    return {
      propsMap: {
        children: 'childs',
        label: 'menuName',
      },
    };
  },
  computed: {
    ...mapGetters('menus', ['MenuTree']),
  },
  methods: {
    ...mapActions('menus', ['fetchMenuTree']),
  },
};
